import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Icon, Label, Button } from "semantic-ui-react";
import _ from "lodash";
import cx from "classnames";

import { fetchUser } from "actions/users";
import Truncate from "react-truncate";

import styles from "./metadata.module.scss";
import { isAccountSuspended } from "components/features/Util/Util";
import {
  deleteIADBMetadata,
  fetchIADBMetadata,
  fetchIADBMetadatas,
} from "../../../../actions/iadb";
import CreateMetaData from "../CreateMetaData";
import ConfirmModal from "../../../ui/ConfirmModal";
import { toast } from "react-toastify";

export default function MetaData({ account, setLoading }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [initialRender, setInitialRender] = useState(true);
  const [updateMetadata, setUpdateMetadata] = useState(null);
  const [updateMetadataOpen, setUpdateMetadataOpen] = useState(false);
  const [metadataId, setMetadataId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const metaDatas = useSelector((state) =>
    _.get(state, "iadb.items", [])
  );
  const loading = useSelector((state) =>
    _.get(state, "iadb.loading")
  );
  

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!loading && account) {
      dispatch(fetchIADBMetadatas({accountId: account.id.toString()}));
    }
  }, []);  

  setTimeout(
    function() {
      setInitialRender(false);
    },
    [3000]
  );  

  const handleEdit = (metadata) => {
    setUpdateMetadata(metadata);
    setUpdateMetadataOpen(true);
  };

  const handleDelete = (id) => {
    setMetadataId(id);
    setShowDeleteConfirmation(true);
  };

  const onModalConfirm= () => {
    dispatch(deleteIADBMetadata({accountId: account.id.toString(),id: metadataId}));
    setShowDeleteConfirmation(false);
    toast.success("metdata deleted successfully");
  }

  const onModalCancel = () => {
    setShowDeleteConfirmation(false);
  }
  return (
    <>
      <Table singleLine className={cx(styles.table)}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2} className={cx(styles.header)}>
              PAGE
            </Table.HeaderCell>
            <Table.HeaderCell width={2} className={cx(styles.header)}>
              ITEM ID
            </Table.HeaderCell>
            <Table.HeaderCell width={3} className={cx(styles.header)}>
              DOCUMENT NUMBER
            </Table.HeaderCell>
            <Table.HeaderCell width={2} className={cx(styles.header)}>
              LANGUAGES
            </Table.HeaderCell>
            <Table.HeaderCell width={6} className={cx(styles.header)}>
              ASSET MAPPING
            </Table.HeaderCell>
            <Table.HeaderCell
              width={1}
              className={cx(styles.header)}
            ></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body className={cx(styles.body)}>
          {!loading && metaDatas.length === 0 && (
            <>
              <Table.Row>
                <Table.Cell colSpan="5" className={cx(styles.cell)}>
                  <div className={cx(styles.noData)}>No Meta Data</div>
                </Table.Cell>
              </Table.Row>
            </>
          )}

          {loading && metaDatas.length === 0 && (
            <>
              <Table.Row>
                <Table.Cell colSpan="5" className={cx(styles.cell)}>
                  <div className={cx(styles.noData)}>
                    Loading
                    <Icon name="sync" loading className={cx(styles.icon)} />
                  </div>
                </Table.Cell>
              </Table.Row>
            </>
          )}

          {metaDatas.length !== 0 && (
            <>
              {metaDatas.map((item, idx) => (
                <>
                  <Table.Row key={idx}>
                    <Table.Cell
                      width={2}
                      className={cx(styles.cell)}
                      textAlign="center"
                    >
                      <div
                        className={cx(styles.text)}
                      >
                        <Truncate width={70} lines={2}>{item.page}</Truncate> 
                      </div>
                    </Table.Cell>
                    <Table.Cell width={2} className={cx(styles.cell)}>
                      <div className={cx(styles.text)}> 
                      <Truncate width={70} lines={2}>{item.itemId}</Truncate>
                       </div>
                    </Table.Cell>
                    <Table.Cell
                      width={2}
                      className={cx(styles.cell)}
                    >
                      <div className={cx(styles.text)}>
                        <Truncate width={70} lines={2}>{item.documentNumber}</Truncate>
                      </div>
                    </Table.Cell>
                    <Table.Cell width={2} className={cx(styles.cell)}>
                      <div className={cx(styles.text)}>{item.language}</div>
                    </Table.Cell>
                    <Table.Cell
                      width={6}
                      className={cx(styles.cell, styles.labelGroup)}
                    >
                      {item.assetMappings &&
                        item.assetMappings.map((mappingItem, index) => {
                          return (
                            <Button className={styles.assetMappingBtn} size="mini" as="div" labelPosition="right">
                              <Button
                                size="mini"
                                className={styles.assetMapping}
                              >
                               <Truncate width={130} lines={2}> {mappingItem.asset} </Truncate>
                              </Button>
                              <Label
                                className={styles.sectionMapping}
                                basic
                                pointing="left"
                              >
                                <Truncate width={130} lines={2}>{mappingItem.section}</Truncate>
                              </Label>
                            </Button>
                          );
                        })}
                    </Table.Cell>
                    <Table.Cell width={2} className={cx(styles.cell)}>
                      <div className={styles.actions}>
                        <div
                          className={styles.actionIcons}
                          onClick={() => handleEdit(item)}
                        >
                          <Icon name="edit outline" />
                          <span>Edit</span>
                        </div>
                        <div
                          className={styles.actionIcons}
                          onClick={ () => handleDelete(item.id)}
                        >
                          <Icon name="trash alternate outline" />
                          <span>Delete</span>
                        </div>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                </>
              ))}
            </>
          )}
        </Table.Body>
      </Table>

      <CreateMetaData
        account={account}
        open={updateMetadataOpen}
        setOpen={setUpdateMetadataOpen}
        metadata={updateMetadata}
      />
      <ConfirmModal
        open={showDeleteConfirmation}
        setOpen={setShowDeleteConfirmation}
        onSave={onModalConfirm}
        onCancel={onModalCancel}
        content={"Are you sure want to delete this meta data?"}
      />
    </>
  );
}
